import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

import { modelOf } from '../../../prop-types';
import ProductStore from '../../../store/ProductStore';
import ConfigStore from '../../../store/ConfigStore';
import ProductList from '../ProductList';
import ContentForState from '../../loader/ContentForState';
import { paramsToQueryIdentifier } from '../../../util/query';

@observer
export class SimpleProductList extends Component {
  constructor(props) {
    super(props);
    if (!this.getCurrentSearchResult()) {
      this.loadProducts();
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.searchParams, this.props.searchParams)) {
      this.loadProducts();
    }
  }

  getQueryIdentifier() {
    return paramsToQueryIdentifier(this.props.searchParams);
  }

  getCurrentSearchResult() {
    const { productStore } = this.props;
    return productStore.productQueryResults.get(this.getQueryIdentifier());
  }

  getCurrentSearchState() {
    const { productStore } = this.props;
    return productStore.productQueryStates.get(this.getQueryIdentifier());
  }

  loadProducts = () => {
    const { productStore, allSections } = this.props;
    productStore
      .loadProducts(this.props.searchParams, allSections)
      .catch((e) => {
        console.error(e);
      });
  };

  render() {
    const {
      productStore,
      searchParams,
      name,
      listComponent: ListComponent,
      completeListingLink,
      preloadOnly,
      singleRowMode,
      requireCanonicalLink,
      ...rest
    } = this.props;

    if (!productStore || !searchParams || preloadOnly) {
      return null;
    }

    return (
      <div className="SimpleProductList">
        <ContentForState
          state={this.getCurrentSearchState()}
          error={productStore.lastError}
          forLoaded={() => (
            <ListComponent
              products={this.getCurrentSearchResult().data}
              name={name}
              completeListingLink={!singleRowMode ? completeListingLink : null}
              cardSettings={{
                requireCanonicalLink: requireCanonicalLink
              }}
              {...rest}
            />
          )}
        />
      </div>
    );
  }
}

SimpleProductList.propTypes = {
  productStore: modelOf(ProductStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  searchParams: PropTypes.object.isRequired,
  name: PropTypes.string,
  listComponent: PropTypes.func,
  completeListingLink: PropTypes.node,
  preloadOnly: PropTypes.bool,
  allSections: PropTypes.bool,
  singleRowMode: PropTypes.bool,
  requireCanonicalLink: PropTypes.bool
};

SimpleProductList.defaultProps = {
  listComponent: ProductList,
  preloadOnly: false,
  allSections: false,
  singleRowMode: false,
  requireCanonicalLink: false
};

export default inject('productStore', 'configStore')(SimpleProductList);



// WEBPACK FOOTER //
// ./src/components/product-list/SimpleProductList/index.jsx